<template>
  <div class="card-item desk-c-pointer" >
    <div class="card-item-icon" >
      <svg v-if="isVisa" width="100%" height="100%" viewBox="0 0 32 32">
        <g class="nc-icon-wrapper">
          <rect x="2" y="7" width="28" height="18" rx="3" ry="3" fill="#fff" stroke-width="0"></rect>
          <path d="m27,7H5c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3v-12c0-1.657-1.343-3-3-3Zm2,15c0,1.103-.897,2-2,2H5c-1.103,0-2-.897-2-2v-12c0-1.103.897-2,2-2h22c1.103,0,2,.897,2,2v12Z" stroke-width="0" opacity=".15"></path>
          <path d="m27,8H5c-1.105,0-2,.895-2,2v1c0-1.105.895-2,2-2h22c1.105,0,2,.895,2,2v-1c0-1.105-.895-2-2-2Z" fill="#fff" opacity=".2" stroke-width="0"></path>
          <path d="m13.392,12.624l-2.838,6.77h-1.851l-1.397-5.403c-.085-.332-.158-.454-.416-.595-.421-.229-1.117-.443-1.728-.576l.041-.196h2.98c.38,0,.721.253.808.69l.738,3.918,1.822-4.608h1.84Z" fill="#1434cb" stroke-width="0"></path>
          <path d="m20.646,17.183c.008-1.787-2.47-1.886-2.453-2.684.005-.243.237-.501.743-.567.251-.032.943-.058,1.727.303l.307-1.436c-.421-.152-.964-.299-1.638-.299-1.732,0-2.95.92-2.959,2.238-.011.975.87,1.518,1.533,1.843.683.332.912.545.909.841-.005.454-.545.655-1.047.663-.881.014-1.392-.238-1.799-.428l-.318,1.484c.41.188,1.165.351,1.947.359,1.841,0,3.044-.909,3.05-2.317" fill="#1434cb" stroke-width="0"></path>
          <path d="m25.423,12.624h-1.494c-.337,0-.62.195-.746.496l-2.628,6.274h1.839l.365-1.011h2.247l.212,1.011h1.62l-1.415-6.77Zm-2.16,4.372l.922-2.542.53,2.542h-1.452Z" fill="#1434cb" stroke-width="0"></path>
          <path fill="#1434cb" stroke-width="0" d="M15.894 12.624L14.446 19.394 12.695 19.394 14.143 12.624 15.894 12.624z"></path>
        </g>
      </svg>
      <svg v-else-if="isMastercard" width="100%" height="100%" viewBox="0 0 32 32">
        <g class="nc-icon-wrapper">
          <rect x="2" y="7" width="28" height="18" rx="3" ry="3" fill="#fff" stroke-width="0"></rect>
          <path d="m27,7H5c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3v-12c0-1.657-1.343-3-3-3Zm2,15c0,1.103-.897,2-2,2H5c-1.103,0-2-.897-2-2v-12c0-1.103.897-2,2-2h22c1.103,0,2,.897,2,2v12Z" stroke-width="0" opacity=".15"></path>
          <path d="m27,8H5c-1.105,0-2,.895-2,2v1c0-1.105.895-2,2-2h22c1.105,0,2,.895,2,2v-1c0-1.105-.895-2-2-2Z" fill="#fff" opacity=".2" stroke-width="0"></path>
          <path fill="#ff5f00" stroke-width="0" d="M13.597 11.677H18.407V20.32H13.597z"></path>
          <path d="m13.902,15.999c0-1.68.779-3.283,2.092-4.322-2.382-1.878-5.849-1.466-7.727.932-1.863,2.382-1.451,5.833.947,7.712,2,1.573,4.795,1.573,6.795,0-1.329-1.038-2.107-2.642-2.107-4.322Z" fill="#eb001b" stroke-width="0"></path>
          <path d="m24.897,15.999c0,3.039-2.459,5.497-5.497,5.497-1.237,0-2.428-.412-3.39-1.176,2.382-1.878,2.795-5.329.916-7.727-.275-.336-.58-.657-.916-.916,2.382-1.878,5.849-1.466,7.712.932.764.962,1.176,2.153,1.176,3.39Z" fill="#f79e1b" stroke-width="0"></path>
        </g>
      </svg>
      <div v-else class="brand-text">
        {{ card.brand }}
      </div>
    </div>
    <div @click="onCardClick" class="desk-c-pointer">
      <div><span>**{{ card.last4 }}</span> <span>{{ card.expYear }}/{{ card.expMonth }}</span></div>
      <div>{{ card.holder }}</div>
    </div>
    <div v-if="showDel" class="icon-delete"  @click="onCardDelete">
      <svg class="desk-c-pointer" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="100%" height="100%" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"/></svg>
    </div>
  </div>
</template>
  
<script>

  export default {
    name: "UserCardItem",
    emits: [
      'cardClick',
      'cardDelete'
    ],
    data:()=>{
      return {}
    },
    props: {
      card: {
        type: Object
      },
      showDel: {
        type: Boolean
      }
    },
    computed: {
      isVisa() {
        return ['visa'].some(el =>  el === this.card.brand?.toLowerCase())
      },
      isMastercard() {
        return ['mastercard', 'master'].some(el =>  el === this.card.brand?.toLowerCase())
      }
    },
    methods: {
      onCardClick() {
        this.$emit('cardClick')
      },
      onCardDelete() {
        this.$emit('cardDelete')
      }
    }
  }
</script>
  
<style scoped lang="scss">
  .card-item {
    display: grid;
    grid-template-columns: 3.375rem 1fr 2rem;
    grid-gap: 0 1rem;
    align-items: center;
    background-color: #2e2e2e;
    border-radius: 0.25rem;
    padding: 0.25rem 1rem;

    .card-item-icon {
      max-height: 3rem;
      display: flex;
      align-items: center;

      .brand-text {
        text-transform: uppercase;
        font-weight: 700;
      }
    }

    .icon-delete {
      color: var(--geoff-danger);
      height: 2rem;
      width: 2rem;
      border-radius: 0.25rem;
      transition:  0.2s ease-in-out;
      outline: 2px solid transparent;

      &:hover {
        outline: 2px solid var(--geoff-danger);
      }
    }
  }
</style>